module.exports = __webpack_public_path__ + "img/9788997379019.52d21a43.jpg";